module.exports = __webpack_public_path__ + "img/map-type-control.c4a14000.svg";